import { emptySplitApi as api } from './emptyApi';
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    sessionGetAll: build.mutation<SessionGetAllApiResponse, SessionGetAllApiArg>({
      query: (queryArg) => ({
        url: `/api/sessions`,
        method: 'POST',
        body: queryArg.pagedAndSortedQueryParametersOfSessionFilters,
        headers: { 'X-Organisation-Id': queryArg['X-Organisation-Id'] },
        params: { with: queryArg['with'] },
      }),
    }),
    sessionGetBySkillsAndDate: build.query<SessionGetBySkillsAndDateApiResponse, SessionGetBySkillsAndDateApiArg>({
      query: (queryArg) => ({
        url: `/api/sessions/skills`,
        headers: { 'X-Organisation-Id': queryArg['X-Organisation-Id'] },
        params: { SkillIds: queryArg.skillIds, DateFrom: queryArg.dateFrom, DateTo: queryArg.dateTo },
      }),
    }),
    sessionGet: build.query<SessionGetApiResponse, SessionGetApiArg>({
      query: (queryArg) => ({ url: `/api/sessions/${queryArg.sessionId}`, headers: { 'X-Organisation-Id': queryArg['X-Organisation-Id'] } }),
    }),
    sessionGetActive: build.query<SessionGetActiveApiResponse, SessionGetActiveApiArg>({
      query: (queryArg) => ({ url: `/api/sessions/active`, headers: { 'X-Organisation-Id': queryArg['X-Organisation-Id'] } }),
    }),
    resultGetById: build.query<ResultGetByIdApiResponse, ResultGetByIdApiArg>({
      query: (queryArg) => ({ url: `/api/results/${queryArg.id}`, headers: { 'X-Organisation-Id': queryArg['X-Organisation-Id'] } }),
    }),
    resultDownloadBulkResults: build.query<ResultDownloadBulkResultsApiResponse, ResultDownloadBulkResultsApiArg>({
      query: (queryArg) => ({
        url: `/api/results/sessions/${queryArg.sessionId}`,
        method: 'POST',
        headers: { 'X-Organisation-Id': queryArg['X-Organisation-Id'] },
        body: queryArg.customerIds,
      }),
    }),
    resultDownloadCertificate: build.query<ResultDownloadCertificateApiResponse, ResultDownloadCertificateApiArg>({
      query: (queryArg) => ({
        url: `/api/results/certificate/${queryArg.customerId}/${queryArg.enrolmentId}/${queryArg.certificate}`,
        headers: { 'X-Organisation-Id': queryArg['X-Organisation-Id'] },
      }),
    }),
    resultDownloadBulkCertificates: build.mutation<ResultDownloadBulkCertificatesApiResponse, ResultDownloadBulkCertificatesApiArg>({
      query: (queryArg) => ({
        url: `/api/results/certificates`,
        method: 'POST',
        body: queryArg.body,
        headers: { 'X-Organisation-Id': queryArg['X-Organisation-Id'] },
      }),
    }),
    resultSendCertificatesByEmail: build.mutation<ResultSendCertificatesByEmailApiResponse, ResultSendCertificatesByEmailApiArg>({
      query: (queryArg) => ({
        url: `/api/results/certificates/emails`,
        method: 'POST',
        body: queryArg.sendCertificatesByEmailRequest,
        headers: { 'X-Organisation-Id': queryArg['X-Organisation-Id'] },
      }),
    }),
    productGetSkillsByProductId: build.query<ProductGetSkillsByProductIdApiResponse, ProductGetSkillsByProductIdApiArg>({
      query: (queryArg) => ({ url: `/api/products/${queryArg.productId}/skills`, headers: { 'X-Organisation-Id': queryArg['X-Organisation-Id'] } }),
    }),
    permissionsGetPermissionTree: build.query<PermissionsGetPermissionTreeApiResponse, PermissionsGetPermissionTreeApiArg>({
      query: () => ({ url: `/api/security/permissionTree` }),
    }),
    permissionsGetPermissionsByOrgId: build.query<PermissionsGetPermissionsByOrgIdApiResponse, PermissionsGetPermissionsByOrgIdApiArg>({
      query: (queryArg) => ({ url: `/api/security/permissions/organisations/${queryArg.organisationId}` }),
    }),
    organisationGet: build.query<OrganisationGetApiResponse, OrganisationGetApiArg>({
      query: () => ({ url: `/api/organisations` }),
    }),
    guardianCreate: build.mutation<GuardianCreateApiResponse, GuardianCreateApiArg>({
      query: (queryArg) => ({ url: `/api/guardians/create`, method: 'POST', body: queryArg.guardianRequest }),
    }),
    enrolmentUpdateEnrollmentData: build.mutation<EnrolmentUpdateEnrollmentDataApiResponse, EnrolmentUpdateEnrollmentDataApiArg>({
      query: (queryArg) => ({
        url: `/api/enrolments/update`,
        method: 'PUT',
        body: queryArg.updateEnrolmentRequest,
        headers: { 'X-Organisation-Id': queryArg['X-Organisation-Id'] },
      }),
    }),
    enrolmentGetEnrolmentSessionByCustomerId: build.query<EnrolmentGetEnrolmentSessionByCustomerIdApiResponse, EnrolmentGetEnrolmentSessionByCustomerIdApiArg>({
      query: (queryArg) => ({ url: `/api/enrolments/customers/${queryArg.customerId}`, headers: { 'X-Organisation-Id': queryArg['X-Organisation-Id'] } }),
    }),
    enrolmentEnrol: build.mutation<EnrolmentEnrolApiResponse, EnrolmentEnrolApiArg>({
      query: (queryArg) => ({
        url: `/api/enrolments/enrol`,
        method: 'PUT',
        body: queryArg.manageEnrolmentRequest,
        headers: { 'X-Organisation-Id': queryArg['X-Organisation-Id'] },
      }),
    }),
    enrolmentUnEnrol: build.mutation<EnrolmentUnEnrolApiResponse, EnrolmentUnEnrolApiArg>({
      query: (queryArg) => ({
        url: `/api/enrolments/unenrol`,
        method: 'PUT',
        body: queryArg.manageEnrolmentRequest,
        headers: { 'X-Organisation-Id': queryArg['X-Organisation-Id'] },
      }),
    }),
    enrolmentResit: build.mutation<EnrolmentResitApiResponse, EnrolmentResitApiArg>({
      query: (queryArg) => ({
        url: `/api/enrolments/resit`,
        method: 'POST',
        body: queryArg.resitRequest,
        headers: { 'X-Organisation-Id': queryArg['X-Organisation-Id'] },
      }),
    }),
    enrolmentResitDetails: build.query<EnrolmentResitDetailsApiResponse, EnrolmentResitDetailsApiArg>({
      query: (queryArg) => ({
        url: `/api/enrolments/resit/sessions/${queryArg.sessionId}`,
        headers: { 'X-Organisation-Id': queryArg['X-Organisation-Id'] },
      }),
    }),
    enrolmentCreateEor: build.mutation<EnrolmentCreateEorApiResponse, EnrolmentCreateEorApiArg>({
      query: (queryArg) => ({
        url: `/api/enrolments/eor`,
        method: 'POST',
        body: queryArg.eorRequest,
        headers: { 'X-Organisation-Id': queryArg['X-Organisation-Id'] },
      }),
    }),
    customerGet: build.query<CustomerGetApiResponse, CustomerGetApiArg>({
      query: (queryArg) => ({ url: `/api/customers/${queryArg.id}`, headers: { 'X-Organisation-Id': queryArg['X-Organisation-Id'] } }),
    }),
    customerGetCustomerByEmail: build.query<CustomerGetCustomerByEmailApiResponse, CustomerGetCustomerByEmailApiArg>({
      query: (queryArg) => ({ url: `/api/customers/email`, params: { email: queryArg.email } }),
    }),
    customerGetCustomersContactEmails: build.mutation<CustomerGetCustomersContactEmailsApiResponse, CustomerGetCustomersContactEmailsApiArg>({
      query: (queryArg) => ({ url: `/api/customers/contact-emails`, method: 'POST', body: queryArg.body }),
    }),
    customerGetAllCustomersBySessionIds: build.query<CustomerGetAllCustomersBySessionIdsApiResponse, CustomerGetAllCustomersBySessionIdsApiArg>({
      query: (queryArg) => ({
        url: `/api/customers/sessions/ids`,
        headers: { 'X-Organisation-Id': queryArg['X-Organisation-Id'] },
        params: { sessionIds: queryArg.sessionIds },
      }),
    }),
    customerGetCustomersEnrolmentBySessionId: build.query<CustomerGetCustomersEnrolmentBySessionIdApiResponse, CustomerGetCustomersEnrolmentBySessionIdApiArg>({
      query: (queryArg) => ({
        url: `/api/customers/${queryArg.sessionId}/customerIds`,
        headers: { 'X-Organisation-Id': queryArg['X-Organisation-Id'] },
        params: { customerIds: queryArg.customerIds },
      }),
    }),
    customerGetAll: build.mutation<CustomerGetAllApiResponse, CustomerGetAllApiArg>({
      query: (queryArg) => ({
        url: `/api/customers`,
        method: 'POST',
        body: queryArg.pagedAndSortedQueryParametersOfCustomerFilters,
        headers: { 'X-Organisation-Id': queryArg['X-Organisation-Id'] },
      }),
    }),
    customerUploadCustomer: build.mutation<CustomerUploadCustomerApiResponse, CustomerUploadCustomerApiArg>({
      query: (queryArg) => ({
        url: `/api/customers/upload-customer`,
        method: 'POST',
        body: queryArg.body,
        headers: { 'X-Organisation-Id': queryArg['X-Organisation-Id'] },
      }),
    }),
    customerUploadAndEnroll: build.mutation<CustomerUploadAndEnrollApiResponse, CustomerUploadAndEnrollApiArg>({
      query: (queryArg) => ({
        url: `/api/customers/upload`,
        method: 'POST',
        body: queryArg.body,
        headers: { 'X-Organisation-Id': queryArg['X-Organisation-Id'] },
      }),
    }),
    customerCreate: build.mutation<CustomerCreateApiResponse, CustomerCreateApiArg>({
      query: (queryArg) => ({
        url: `/api/customers/create`,
        method: 'POST',
        body: queryArg.createAndEnrolCustomersRequest,
        headers: { 'X-Organisation-Id': queryArg['X-Organisation-Id'] },
      }),
    }),
    customerUpdatePersonalData: build.mutation<CustomerUpdatePersonalDataApiResponse, CustomerUpdatePersonalDataApiArg>({
      query: (queryArg) => ({
        url: `/api/customers/update/personal-data`,
        method: 'PATCH',
        body: queryArg.customerPersonalDataRequest,
        headers: { 'X-Organisation-Id': queryArg['X-Organisation-Id'] },
      }),
    }),
    customerUpdate: build.mutation<CustomerUpdateApiResponse, CustomerUpdateApiArg>({
      query: (queryArg) => ({
        url: `/api/customers/update/identification-document`,
        method: 'PATCH',
        body: queryArg.customerIdentificationDocumentRequest,
        headers: { 'X-Organisation-Id': queryArg['X-Organisation-Id'] },
      }),
    }),
    customerGetCertificatesBySessionId: build.query<CustomerGetCertificatesBySessionIdApiResponse, CustomerGetCertificatesBySessionIdApiArg>({
      query: (queryArg) => ({
        url: `/api/customers/session/${queryArg.sessionId}/certificates`,
        headers: { 'X-Organisation-Id': queryArg['X-Organisation-Id'] },
      }),
    }),
    countryGetAll: build.query<CountryGetAllApiResponse, CountryGetAllApiArg>({
      query: () => ({ url: `/api/countries` }),
    }),
    dictionariesGetAllSpecialRequirements: build.query<DictionariesGetAllSpecialRequirementsApiResponse, DictionariesGetAllSpecialRequirementsApiArg>({
      query: () => ({ url: `/api/dictionaries/special-requirements` }),
    }),
    dictionariesGetAllIdentificationDocumentTypes: build.query<
      DictionariesGetAllIdentificationDocumentTypesApiResponse,
      DictionariesGetAllIdentificationDocumentTypesApiArg
    >({
      query: () => ({ url: `/api/dictionaries/document-types` }),
    }),
    dictionariesGetAllReasonsForTakingTest: build.query<DictionariesGetAllReasonsForTakingTestApiResponse, DictionariesGetAllReasonsForTakingTestApiArg>({
      query: () => ({ url: `/api/dictionaries/test-reasons` }),
    }),
    dictionariesGetAllMinorPickupPersons: build.query<DictionariesGetAllMinorPickupPersonsApiResponse, DictionariesGetAllMinorPickupPersonsApiArg>({
      query: () => ({ url: `/api/dictionaries/minor-pickup-persons` }),
    }),
    dictionariesGetAllRelationships: build.query<DictionariesGetAllRelationshipsApiResponse, DictionariesGetAllRelationshipsApiArg>({
      query: () => ({ url: `/api/dictionaries/relationships` }),
    }),
    attendanceDownloadAttendance: build.mutation<AttendanceDownloadAttendanceApiResponse, AttendanceDownloadAttendanceApiArg>({
      query: (queryArg) => ({
        url: `/api/attendances/${queryArg.sessionId}`,
        method: 'POST',
        body: queryArg.body,
        headers: { 'X-Organisation-Id': queryArg['X-Organisation-Id'] },
      }),
    }),
    applicationGetApplicationsWithAccess: build.query<ApplicationGetApplicationsWithAccessApiResponse, ApplicationGetApplicationsWithAccessApiArg>({
      query: () => ({ url: `/api/applications` }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as codegenApi };
export type SessionGetAllApiResponse = /** status 200  */ PagedResultOfSessionWithCustomerCountResponseAndAvailableSessionFilters;
export type SessionGetAllApiArg = {
  with?: string[] | null;
  'X-Organisation-Id'?: string | null;
  pagedAndSortedQueryParametersOfSessionFilters: PagedAndSortedQueryParametersOfSessionFilters;
};
export type SessionGetBySkillsAndDateApiResponse = /** status 200  */ SessionResponse[];
export type SessionGetBySkillsAndDateApiArg = {
  /** List of skill ids for which session are planned */
  skillIds?: string[] | null;
  /** Date from which sessions are planned */
  dateFrom?: string;
  /** Date to which sessions are planned */
  dateTo?: string;
  'X-Organisation-Id'?: string | null;
};
export type SessionGetApiResponse = /** status 200  */ SessionResponse;
export type SessionGetApiArg = {
  sessionId: string;
  'X-Organisation-Id'?: string | null;
};
export type SessionGetActiveApiResponse = /** status 200  */ SessionResponse[];
export type SessionGetActiveApiArg = {
  'X-Organisation-Id'?: string | null;
};
export type ResultGetByIdApiResponse = /** status 200  */ ResultDto;
export type ResultGetByIdApiArg = {
  id: string;
  'X-Organisation-Id'?: string | null;
};
export type ResultDownloadBulkResultsApiResponse = unknown;
export type ResultDownloadBulkResultsApiArg = {
  customerIds: string[] | null;
  sessionId: string;
  'X-Organisation-Id'?: string | null;
};
export type ResultDownloadCertificateApiResponse = unknown;
export type ResultDownloadCertificateApiArg = {
  customerId: string;
  enrolmentId: string;
  certificate: string;
  'X-Organisation-Id'?: string | null;
};
export type ResultDownloadBulkCertificatesApiResponse = unknown;
export type ResultDownloadBulkCertificatesApiArg = {
  'X-Organisation-Id'?: string | null;
  body: CertificateDownloadRequest[];
};
export type ResultSendCertificatesByEmailApiResponse = unknown;
export type ResultSendCertificatesByEmailApiArg = {
  'X-Organisation-Id'?: string | null;
  sendCertificatesByEmailRequest: SendCertificatesByEmailRequest;
};
export type ProductGetSkillsByProductIdApiResponse = /** status 200  */ SkillsDto[];
export type ProductGetSkillsByProductIdApiArg = {
  productId: string;
  'X-Organisation-Id'?: string | null;
};
export type PermissionsGetPermissionTreeApiResponse = /** status 200  */ OrganisationTreeDto;
export type PermissionsGetPermissionTreeApiArg = void;
export type PermissionsGetPermissionsByOrgIdApiResponse = /** status 200  */ PermissionDto[];
export type PermissionsGetPermissionsByOrgIdApiArg = {
  organisationId: string;
};
export type OrganisationGetApiResponse = /** status 200  */ CustomerDataCollectedConfiguration;
export type OrganisationGetApiArg = void;
export type GuardianCreateApiResponse = unknown;
export type GuardianCreateApiArg = {
  guardianRequest: GuardianRequest;
};
export type EnrolmentUpdateEnrollmentDataApiResponse = unknown;
export type EnrolmentUpdateEnrollmentDataApiArg = {
  'X-Organisation-Id'?: string | null;
  updateEnrolmentRequest: UpdateEnrolmentRequest;
};
export type EnrolmentGetEnrolmentSessionByCustomerIdApiResponse = /** status 200  */ EnrolmentSessionResponse[];
export type EnrolmentGetEnrolmentSessionByCustomerIdApiArg = {
  customerId: string;
  'X-Organisation-Id'?: string | null;
};
export type EnrolmentEnrolApiResponse = /** status 200  */ ManageEnrolmentResponse[];
export type EnrolmentEnrolApiArg = {
  'X-Organisation-Id'?: string | null;
  manageEnrolmentRequest: ManageEnrolmentRequest;
};
export type EnrolmentUnEnrolApiResponse = /** status 200  */ ManageEnrolmentResponse[];
export type EnrolmentUnEnrolApiArg = {
  'X-Organisation-Id'?: string | null;
  manageEnrolmentRequest: ManageEnrolmentRequest;
};
export type EnrolmentResitApiResponse = /** status 200  */ Result;
export type EnrolmentResitApiArg = {
  'X-Organisation-Id'?: string | null;
  resitRequest: ResitRequest;
};
export type EnrolmentResitDetailsApiResponse = /** status 200  */ ResitDetailsDto;
export type EnrolmentResitDetailsApiArg = {
  sessionId: string;
  'X-Organisation-Id'?: string | null;
};
export type EnrolmentCreateEorApiResponse = /** status 201  */ CreateEorResponse;
export type EnrolmentCreateEorApiArg = {
  'X-Organisation-Id'?: string | null;
  eorRequest: EorRequest;
};
export type CustomerGetApiResponse = /** status 200  */ CustomerDto;
export type CustomerGetApiArg = {
  id: string;
  'X-Organisation-Id'?: string | null;
};
export type CustomerGetCustomerByEmailApiResponse = /** status 200  */ CustomerDto;
export type CustomerGetCustomerByEmailApiArg = {
  email?: string | null;
};
export type CustomerGetCustomersContactEmailsApiResponse = /** status 200  */ CustomerContactEmail[];
export type CustomerGetCustomersContactEmailsApiArg = {
  body: string[];
};
export type CustomerGetAllCustomersBySessionIdsApiResponse = /** status 200  */ CustomerWithPaymentsDto[];
export type CustomerGetAllCustomersBySessionIdsApiArg = {
  sessionIds?: string[] | null;
  'X-Organisation-Id'?: string | null;
};
export type CustomerGetCustomersEnrolmentBySessionIdApiResponse = /** status 200  */ CustomerEnrolmentResponse[];
export type CustomerGetCustomersEnrolmentBySessionIdApiArg = {
  sessionId: string;
  customerIds?: string[] | null;
  'X-Organisation-Id'?: string | null;
};
export type CustomerGetAllApiResponse = /** status 200  */ PagedResultOfCustomerWithCountersResponse;
export type CustomerGetAllApiArg = {
  'X-Organisation-Id'?: string | null;
  pagedAndSortedQueryParametersOfCustomerFilters: PagedAndSortedQueryParametersOfCustomerFilters;
};
export type CustomerUploadCustomerApiResponse = /** status 200  */ CustomerDto[];
export type CustomerUploadCustomerApiArg = {
  'X-Organisation-Id'?: string | null;
  body: {
    ContentType?: string | null;
    ContentDisposition?: string | null;
    Headers?: any[] | null;
    Length?: number;
    Name?: string | null;
    FileName?: string | null;
    SessionId?: string | null;
    VenueId?: string | null;
  };
};
export type CustomerUploadAndEnrollApiResponse = /** status 200  */ CustomerDto[];
export type CustomerUploadAndEnrollApiArg = {
  'X-Organisation-Id'?: string | null;
  body: {
    ContentType?: string | null;
    ContentDisposition?: string | null;
    Headers?: any[] | null;
    Length?: number;
    Name?: string | null;
    FileName?: string | null;
    SessionId?: string | null;
    VenueId?: string | null;
  };
};
export type CustomerCreateApiResponse = /** status 200  */ CustomerDto[];
export type CustomerCreateApiArg = {
  'X-Organisation-Id'?: string | null;
  createAndEnrolCustomersRequest: CreateAndEnrolCustomersRequest;
};
export type CustomerUpdatePersonalDataApiResponse = unknown;
export type CustomerUpdatePersonalDataApiArg = {
  'X-Organisation-Id'?: string | null;
  customerPersonalDataRequest: CustomerPersonalDataRequest;
};
export type CustomerUpdateApiResponse = unknown;
export type CustomerUpdateApiArg = {
  'X-Organisation-Id'?: string | null;
  customerIdentificationDocumentRequest: CustomerIdentificationDocumentRequest;
};
export type CustomerGetCertificatesBySessionIdApiResponse = /** status 200  */ CustomerCertificateResponse[];
export type CustomerGetCertificatesBySessionIdApiArg = {
  sessionId: string;
  'X-Organisation-Id'?: string | null;
};
export type CountryGetAllApiResponse = /** status 200  */ Country[];
export type CountryGetAllApiArg = void;
export type DictionariesGetAllSpecialRequirementsApiResponse = /** status 200  */ DictionaryDto[];
export type DictionariesGetAllSpecialRequirementsApiArg = void;
export type DictionariesGetAllIdentificationDocumentTypesApiResponse = /** status 200  */ DictionaryDto[];
export type DictionariesGetAllIdentificationDocumentTypesApiArg = void;
export type DictionariesGetAllReasonsForTakingTestApiResponse = /** status 200  */ DictionaryDto[];
export type DictionariesGetAllReasonsForTakingTestApiArg = void;
export type DictionariesGetAllMinorPickupPersonsApiResponse = /** status 200  */ DictionaryDto[];
export type DictionariesGetAllMinorPickupPersonsApiArg = void;
export type DictionariesGetAllRelationshipsApiResponse = /** status 200  */ DictionaryDto[];
export type DictionariesGetAllRelationshipsApiArg = void;
export type AttendanceDownloadAttendanceApiResponse = unknown;
export type AttendanceDownloadAttendanceApiArg = {
  sessionId: string;
  'X-Organisation-Id'?: string | null;
  body: string[];
};
export type ApplicationGetApplicationsWithAccessApiResponse = /** status 200  */ ApplicationWithAccessResponse[];
export type ApplicationGetApplicationsWithAccessApiArg = void;
export type SectionDto = {
  id?: string | null;
  description?: string | null;
};
export type VenueDto = {
  id?: string | null;
  name?: string | null;
  timezone?: string | null;
  capacity?: number;
  city?: string | null;
  countryId?: number;
  address?: string | null;
  specialRequirements?: string[] | null;
  cityId?: number;
  organisationId?: string | null;
  country?: string | null;
  countryCode?: string | null;
};
export type PackageDto = {
  packageId?: string | null;
  windowId?: string | null;
  skills?: SectionDto[] | null;
};
export type SessionResponse = {
  id: string;
  name?: string;
  startDateTimeUtc?: string;
  endDateTimeUtc?: string;
  timeSlotDescription?: string;
  seatsAllocation?: number;
  seatsAvailable?: number;
  seatsReservation?: number;
  productId?: string;
  packageId?: string;
  windowId?: string;
  sessionComponents?: string[];
  skills?: SectionDto[];
  sessionStatus?: string;
  sessionStatusEnum?: SessionStatus;
  sessionStatusId?: string;
  isB2B?: boolean;
  venue?: VenueDto;
  productName?: string;
  productVariantName?: string;
  productCode?: string;
  packages?: PackageDto[];
  deliveryMode?: string;
};
export type SessionWithCustomerCountResponse = SessionResponse & {
  customerCount?: number | null;
  failCount?: number | null;
};
export type PagedResultOfSessionWithCustomerCountResponse = {
  results?: SessionWithCustomerCountResponse[] | null;
  totalCount?: number;
};
export type AvailableVenueFilter = {
  id?: string;
  name?: string | null;
};
export type AvailableProductFilter = {
  id?: string;
  name?: string | null;
};
export type AvailableSessionFilters = {
  venueFilters?: AvailableVenueFilter[] | null;
  productFilters?: AvailableProductFilter[] | null;
};
export type PagedResultOfSessionWithCustomerCountResponseAndAvailableSessionFilters = PagedResultOfSessionWithCustomerCountResponse & {
  availableFilters?: AvailableSessionFilters | null;
};
export type PaginationParameters = {
  page?: number;
  pageSize?: number;
};
export type SortingParameters = {
  sortField?: string | null;
  sortDir?: SortDirection;
};
export type PaginationAndSortingParameters = {
  pagination?: PaginationParameters | null;
  sorting?: SortingParameters | null;
  isSortingSpecified?: boolean;
  isPaginationSpecified?: boolean;
};
export type SessionFilters = {
  search?: string | null;
  venueIds?: string[] | null;
  productIds?: string[] | null;
  from?: string | null;
  to?: string | null;
  origin?: SessionOrigin | null;
  statuses?: SessionStatus[] | null;
};
export type PagedAndSortedQueryParametersOfSessionFilters = PaginationAndSortingParameters & {
  filter?: SessionFilters | null;
};
export type Scoring = {
  maxScore?: number | null;
  rawScore?: number | null;
  grade?: string | null;
  maxScaledScore?: number | null;
  scaledScore?: number | null;
};
export type Section = {
  name?: string | null;
  reference?: string | null;
  startedAt?: string;
  completedAt?: string;
  maxScore?: number | null;
  rawScore?: number | null;
  grade?: string | null;
  maxScaledScore?: number | null;
  scaledScore?: number | null;
};
export type ResultDto = {
  enrolmentId?: string | null;
  customerId?: string | null;
  testCentreId?: string | null;
  startedAt?: string | null;
  completedAt?: string | null;
  scoring?: Scoring | null;
  sections?: Section[] | null;
  sessionId?: string | null;
  certificate?: string | null;
  generateCertificateBlocked?: boolean;
  generateCertificateBlockedReason?: string | null;
  eorAvailable?: boolean;
};
export type CertificateDownloadRequest = {
  customerId?: string | null;
  enrolmentId?: string | null;
  certificateId?: string | null;
  certificateFileName?: string | null;
};
export type CertificateToSend = {
  customerId?: string | null;
  enrolmentId?: string | null;
  certificateId?: string;
};
export type SendCertificatesByEmailRequest = {
  certificatesToSend?: CertificateToSend[] | null;
};
export type SkillsDto = {
  sectionId?: string | null;
  component?: string | null;
};
export type OrganisationTreeDto = {
  id?: string | null;
  parentId?: string | null;
  name?: string | null;
  hasAccess?: boolean;
  type?: string | null;
  canCommunicateWithCandidate?: boolean | null;
  children?: OrganisationTreeDto[] | null;
};
export type PermissionDto = {
  shortCode?: string | null;
};
export type Column = {
  headerName?: string | null;
  order?: number;
  propertyName?: string | null;
};
export type Table = {
  columns?: Column[] | null;
};
export type CustomerDataCollectedConfiguration = {
  customerTableSettings?: Table | null;
};
export type GuardianInfo = {
  fullName?: string | null;
  telephone?: string | null;
  relationshipId?: number;
  ageDeclaration?: boolean | null;
};
export type GuardianRequest = GuardianInfo & {
  enrolmentId?: string | null;
};
export type UpdateEnrolmentRequest = {
  enrolmentId?: string | null;
  sessionId?: string | null;
  venueId?: string | null;
  customerId?: string | null;
  hasSpecialRequirements?: boolean | null;
  specialRequirementId?: number | null;
  reasonForTakingTestId?: number | null;
  reasonForTakingTestOtherReason?: string | null;
  minorPickUp?: MinorPickUp | null;
  packageId?: string | null;
  windowId?: string | null;
  guardian?: GuardianInfo[] | null;
};
export type EnrolmentResponse = {
  customerId?: string;
  enrolmentId?: string;
  sessionId?: string;
  venueId?: string;
  hasSpecialRequirement?: boolean;
  specialRequirementId?: number | null;
  reasonForTakingTestId?: number | null;
  reasonForTakingTestOtherReason?: string;
  status?: EnrolmentStatus;
  lastModifiedOn?: string | null;
  createdOn?: string;
  origin?: Origin | null;
  resultId?: string;
  keyCode?: string;
  providerId?: string | null;
  minorPickUp?: MinorPickUp | null;
  guardians?: GuardianInfo[];
  providerErrorMessages?: string;
  isResit?: boolean;
  isEor?: boolean;
  windowId?: string;
  packageId?: string;
};
export type PaymentResponse = {
  statusCode?: string;
  statusName?: string;
  createdOn?: string;
};
export type EnrolmentSessionResponse = {
  enrolment: EnrolmentResponse;
  session: SessionResponse;
  payments: PaymentResponse[];
};
export type AddressDto = {
  residenceCountryId?: number | null;
  addressLine1?: string | null;
  addressLine2?: string | null;
  city?: string | null;
  postCode?: string | null;
};
export type IdentificationDocumentDto = {
  typeId?: number | null;
  documentNumber?: string | null;
  expiryDate?: string | null;
  issuingAuthority?: string | null;
  issuingCountryId?: number | null;
};
export type ParentDto = {
  parentFirstName?: string | null;
  parentLastName?: string | null;
  parentGender?: GenderType;
  parentDateOfBirth?: string | null;
};
export type BaseCustomerDto = {
  firstName?: string | null;
  lastName?: string | null;
  dateOfBirth?: string | null;
  gender?: GenderType;
  otherGenders?: string | null;
  isGDPRConsentProvided?: boolean | null;
  email?: string | null;
  address?: AddressDto | null;
  mobileNumber?: string | null;
  identificationDocument?: IdentificationDocumentDto | null;
  parentId?: string | null;
  parentEmail?: string | null;
  minorPickUpOption?: MinorPickUp | null;
  guardianInfo?: GuardianInfo | null;
  parentData?: ParentDto | null;
  origin?: Origin2 | null;
  marketingPreference?: MarketingPreferenceType | null;
  rowNumber?: number | null;
  providerStatus?: ProviderStatus | null;
  providerErrorMessages?: string | null;
  businessId?: string | null;
};
export type PropertyName = {
  value?: string | null;
  index?: number | null;
};
export type Error = {
  code?: string | null;
  message?: string | null;
  metadata?: {
    [key: string]: any;
  } | null;
  propertyName?: PropertyName | null;
};
export type ManageEnrolmentResponse = BaseCustomerDto & {
  customerId?: string | null;
  enrolmentId?: string | null;
  errors?: Error[] | null;
};
export type CustomerWithGuardian = {
  customerId?: string | null;
  minorPickup?: MinorPickUp;
  guardians?: GuardianInfo[] | null;
};
export type ManageEnrolmentRequest = {
  sessionId?: string | null;
  venueId?: string | null;
  packageId?: string | null;
  windowId?: string | null;
  customers?: CustomerWithGuardian[] | null;
};
export type Result = {
  isFailure?: boolean;
  isSuccess?: boolean;
  error?: Error[] | null;
};
export type ResitCustomer = {
  customerId?: string | null;
  enrolmentId?: string | null;
};
export type ResitRequest = {
  customers?: ResitCustomer[] | null;
  sections?: string[] | null;
  sessionId?: string | null;
  venueId?: string | null;
};
export type ResitDetailsDto = {
  totalEnrolments?: number;
  totalResultsAvailable?: number;
  isResitAllowed?: boolean;
  isDownloadCertificateAllowed?: boolean;
};
export type CreateEorResponse = {
  eorId?: number;
};
export type EorRequest = {
  enrolmentId?: string | null;
  sectionBizs?: string[] | null;
};
export type CustomerDto = BaseCustomerDto & {
  id?: string;
  status?: EnrolmentStatus;
  enrolmentId?: string | null;
  isResitActive?: boolean;
  isResitAvailable?: boolean;
  eorStatus?: EorStatus | null;
  errors?: Error[] | null;
};
export type CustomerContactEmail = {
  customerId?: string | null;
  email?: string | null;
};
export type PaymentDto = {
  statusCode?: string | null;
  statusName?: string | null;
  createdOn?: string;
};
export type CustomerWithPaymentsDto = {
  customer?: CustomerDto | null;
  payments?: PaymentDto[] | null;
  isCertificateSent?: boolean;
};
export type CustomerEnrolmentResponse = {
  customerId?: string | null;
  parentId?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  dateOfBirth?: string | null;
  gender?: GenderType;
  address?: AddressDto | null;
  identificationDocument?: IdentificationDocumentDto | null;
  businessId?: string | null;
  enrolmentId?: string | null;
  enroledOn?: string | null;
  specialRequirement?: string | null;
  specialRequirementId?: number | null;
  keycode?: string | null;
  enrolmentStatus?: EnrolmentStatus | null;
  resit?: boolean;
  providerErrorMessages?: string | null;
};
export type CustomerWithCountersResponse = BaseCustomerDto & {
  id?: string;
  enrolmentCount?: number;
};
export type PagedResultOfCustomerWithCountersResponse = {
  results?: CustomerWithCountersResponse[] | null;
  totalCount?: number;
};
export type CustomerFilters = {
  origin?: Origin | null;
  search?: string | null;
};
export type PagedAndSortedQueryParametersOfCustomerFilters = PaginationAndSortingParameters & {
  filter?: CustomerFilters | null;
};
export type CustomerWithEnrolmentRequest = {
  customer?: BaseCustomerDto | null;
  hasSpecialRequirements?: boolean | null;
  specialRequirementId?: number | null;
  reasonForTakingTestId?: number | null;
  reasonForTakingTestOtherReason?: string | null;
};
export type CreateAndEnrolCustomersRequest = {
  sessionId?: string | null;
  venueId?: string | null;
  packageId?: string | null;
  windowId?: string | null;
  customerWithEnrolment?: CustomerWithEnrolmentRequest[] | null;
};
export type CustomerPersonalDataRequest = {
  id?: string;
  firstName?: string | null;
  lastName?: string | null;
  dateOfBirth?: string | null;
  gender?: GenderType;
  otherGenders?: string | null;
  email?: string | null;
  address?: AddressDto | null;
  isGDPRConsentProvided?: boolean | null;
  mobileNumber?: string | null;
  marketingPreference?: MarketingPreferenceType | null;
};
export type CustomerIdentificationDocumentRequest = {
  id?: string;
  identificationDocument?: IdentificationDocumentDto | null;
};
export type CustomerCertificateResponse = {
  customerId?: string | null;
  certificateId?: string;
};
export type Country = {
  id?: number;
  isoCode?: string | null;
  name?: string | null;
};
export type DictionaryDto = {
  id?: number;
  name?: string | null;
};
export type ApplicationResponse = {
  id?: number;
  shortCode?: string | null;
  name?: string | null;
};
export type ApplicationWithAccessResponse = ApplicationResponse & {
  appUrl?: string | null;
  hasAccess?: boolean;
  hasRole?: boolean;
};
export enum SessionStatus {
  Created = 1,
  Canceled = 2,
  Completed = 3,
  ClosedForRegistration = 4,
}
export enum SessionOrigin {
  B2B = 1,
  B2C = 2,
}
export enum SortDirection {
  Undefined = 0,
  Asc = 1,
  Desc = 2,
}
export enum MinorPickUp {
  Itself = 1,
  Parent = 2,
  Guardian = 3,
}
export enum EnrolmentStatus {
  Error = 0,
  Created = 1,
  EnrolRequested = 2,
  Enroled = 3,
  EnrolFailed = 4,
  UnEnrolRequested = 5,
  Unenroled = 6,
  UnenrolFailed = 7,
  EnrolIgnored = 8,
}
export enum Origin {
  B2B = 1,
  B2C = 2,
}
export enum GenderType {
  NotSpecified = 0,
  Male = 1,
  Female = 2,
  Other = 3,
}
export enum Origin2 {
  B2B = 'B2B',
  B2C = 'B2C',
}
export enum MarketingPreferenceType {
  NotSpecified = 0,
  DoNotSend = 1,
  BcOnly = 2,
  BcAndThirdParties = 3,
}
export enum ProviderStatus {
  Success = 2,
}
export enum EorStatus {
  Error = 0,
  EorCreated = 1,
  EorRequested = 2,
  EorCompleted = 3,
}
